export default __webpack_public_path__ + "9fb85c067cc892dcdb1f9c71a963fb00.png";